export default __webpack_public_path__ + "./images/jp.c103cc6a.png";